// extracted by mini-css-extract-plugin
export var addressFields = "_ja-0";
export var animationContainer = "_ja-1";
export var footer = "_ja-2";
export var lineItems = "_ja-3";
export var modalContent = "_ja-4";
export var orderName = "_ja-5";
export var strong = "_ja-6";
export var warning = "_ja-7";